module.exports = __webpack_public_path__ + "static/media/et.8df6b080.svg";